<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-3 col-3">
                    <h2>Traders</h2>
                    </div>
                    <div class="col-lg-9 col-9 text-right bid">
                        <div class="d-flex justify-content-end">
                            <button  type="button" @click="addTrader()" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW TRADER</button>
                            <select @change="searchCustomer()" v-model="traderStatus" class="form-control w100p mr-1" aria-label="Default select example">
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Deactive</option>
                            </select>
                            <!-- <button type="button" class="btn btn-warning rounded"> Filter</button>  -->
                            
                    <!--<button type="button" class="btn btn-info"><i class="fas fa-file"></i> IMPORT DATA</button> -->
                    <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                        <i @click="searchCustomer()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchCustomer" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form> 
                        </div>
                     
                                    
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                <div class="col-xl-12">  
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'traderId'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'traderId'  ? 'sort-desc' : '']"  
                                    @click="sort('traderId')" >Trader ID</th> 
                                <th 
                                    scope="col" 
                                    class="sort text-left"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                                    @click="sort('firstName')" >First Name</th>  
                               <th 
                                    scope="col" 
                                    class="sort text-left"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'lastName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'lastName'  ? 'sort-desc' : '']"  
                                    @click="sort('lastName')" >Last Name</th>
                                <!-- <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Status</th>     -->
                                <th 
                                    scope="col" 
                                    class="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="trader in traders" :key="trader.id" >
                                <td class="text-primary">{{trader.traderId}}</td>
                                <td class="text-left">{{trader.firstName}}</td>
                                <td class="text-left">{{trader.lastName}}</td>
                                <!-- <td class="text-center"><span class="badge" v-bind:class="trader.status == 'ACTIVE' ? 'active' : 'deactive'">{{trader.status == 'ACTIVE' ? 'ACTIVE' : 'INACTIVE'}}</span></td> -->
                                <td class="text-center">
                                    <div class="d-inline-flex"> 
                                        <a  @click="editTrader(trader)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                                        <!-- <a  @click="deleteTrader(trader)" class="btn ibtn btn-outline-danger"><i class="fas fa-trash-alt"></i></a> -->
                                        <button @click="deleteTrader(trader)" v-if="trader.status == 'ACTIVE'" type="button" class="btn btn-danger"> DEACTIVATE</button>
                                        <button @click="deleteTrader(trader)" v-if="trader.status == 'INACTIVE'" type="button" class="btn btn-primary btnpx" >ACTIVATE</button>

                                        
                                    </div>  
                                </td>
                            </tr>    
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getPLTraderList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    <pltraderaddmodal 
        v-if="pladdTraderModalOpen"
        v-bind:traderData="selectedTrader"
        @close="closePlAddModal()"  /> 

    </div>
</template>
<script>
import pltraderaddmodal from "./ImsProfitLossAddOrEditTraderModal";
import authService from "@/authService";
import config from "@/config";
export default {
  name: "ImsProfitLossTraders.vue",
   components: {
    pltraderaddmodal
  },
  data() {
    return {
        pladdTraderModalOpen : false,
        selectedTrader : {},
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "traderId",
        sortOrder: "ASC",
        traders : [],
        traderStatus : "ACTIVE"
    };
  },
  methods: {
    addTrader(){
        this.selectedTrader = {};
        this.pladdTraderModalOpen = true
    },
    editTrader(data){
        this.selectedTrader = data;
        this.pladdTraderModalOpen = true
    },
    closePlAddModal(){
        this.pladdTraderModalOpen = false;
        this.getPLTraderList();
    },
    searchCustomer(){
        this.getPLTraderList(); 
    },
    clearSearch(){
        this.searchValue = "";
        this.getPLTraderList(); 
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getPLTraderList();
    },
    deleteTrader(trader){
        var status = trader.status == 'ACTIVE' ? 'deactivate' : 'activate';
        var message = "Are you sure you want to "+ status +" this trader?";
        this.$confirm(message,"","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            var data = { "id":trader.id,"status": trader.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'}
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .put(config.baseUrlBidSide + "/pnl/trader-status-update", data, auth)
            .then(() => {
                this.loading = false;              
                this.getPLTraderList();  
                let msg = "Trader "+status+ "d successfully";
                this.$alert(msg,"","success");

            })
            .catch(() => {
                this.loading = false;              
            });
        });
    },
    getPLTraderList(){
        ///pnl/trader-list
        this.loading = true;
        // if (!currentPage) {
        //   currentPage = 1;
        // }
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .get(config.baseUrlBidSide + 
            "/pnl/trader-list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            this.traderStatus+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder,
            auth
        )
        .then((result) => {
            this.traders = result.data.content;
            this.totalRows = result.data.pageInfo.totalElements;
            this.loading = false;                           
        })
        .catch(() => {
            this.loading = false;              
        });
    }
    
  },
  mounted() {
    this.getPLTraderList();
  }
};
</script>